"use client";

import { c as _c } from "react/compiler-runtime";
import { sanitizeIconifySvgMarkup } from "@multi-tenant-cms/builder/runtime/iconifySvg";
import { daysUntilIso, formatReplicaDeadlineCaption, lookupNavIcon, replicaGridClassName, replicaGroupIconAliasIds, replicaIsLeftTabsLayout, replicaLinkIconAliasIds, replicaPanelUsesAsideRail, replicaShowsDeadlinesAside, replicaShowsFeaturedAside, replicaStatusSitsInGrid, resolvePanelGroups } from "@multi-tenant-cms/builder/ui/lib/replicaMegaMenuHeader";
import { type AdvancedMegaMenuHeaderActionLink, type AdvancedMegaMenuNavIcon, type GroupHeaderDenseGroup, type GroupHeaderFeaturedCard, type GroupHeaderLinkBadge, type GroupHeaderPanelConfig, type GroupHeaderProductCard, type MenuRootNode, parseGroupHeaderProductMarkKind } from "@multi-tenant-cms/types/menu";
import ghh from "@multi-tenant-cms/ui/styles/group-header.module.css";
import { type CSSProperties, type KeyboardEvent as ReactKeyboardEvent, type ReactNode, useEffect, useId, useState } from "react";
import { NavIconSpan } from "./navIconSpan";
type MegaTabRoot = Extract<MenuRootNode, {
  itemKind: "mega_tab";
}>;
function replicaGridClass(layout: GroupHeaderPanelConfig["layout"] | undefined): string {
  const kind = replicaGridClassName(layout);
  if (kind === "products") {
    return ghh.pgSoftware;
  }
  if (kind === "resources") {
    return ghh.pgResources;
  }
  if (kind === "company") {
    return ghh.pgCompany;
  }
  if (kind === "tabs") {
    return ghh.pgTabs;
  }
  return ghh.pgServices;
}
function DenseGroup(t0) {
  const $ = _c(27);
  const {
    group,
    badges,
    hideHeading: t1,
    navIcons,
    root
  } = t0;
  const hideHeading = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== group.more?.href) {
    t2 = group.more?.href?.trim();
    $[0] = group.more?.href;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const moreHref = t2;
  const showMore = Boolean(moreHref && moreHref !== "#");
  const count = group.items.length + (showMore ? 1 : 0);
  let t3;
  if ($[2] !== count || $[3] !== group || $[4] !== hideHeading || $[5] !== navIcons || $[6] !== root) {
    t3 = hideHeading ? <span className={ghh.srOnly}>{group.label} ({count})</span> : <h3><span className={`${ghh.grpTitleMain} ${ghh.iconLabel}`}><NavIconSpan className={ghh.navIcon} icon={lookupNavIcon(navIcons, group.id, replicaGroupIconAliasIds(root, group))} />{group.label}</span><span className={ghh.grpCount}>{count}</span></h3>;
    $[2] = count;
    $[3] = group;
    $[4] = hideHeading;
    $[5] = navIcons;
    $[6] = root;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== badges || $[9] !== group.items || $[10] !== navIcons || $[11] !== root) {
    let t5;
    if ($[13] !== badges || $[14] !== navIcons || $[15] !== root) {
      t5 = link => {
        const badge = badges[link.id];
        const tag = link.badge || badge?.label;
        const soft = link.badgeTone === "soft" || badge?.tone === "soft";
        return <li key={link.id}><a href={link.href} rel={link.openInNewTab ? "noopener noreferrer" : undefined} target={link.openInNewTab ? "_blank" : undefined}><span className={ghh.iconLabel}><NavIconSpan className={ghh.navIcon} icon={lookupNavIcon(navIcons, link.id, replicaLinkIconAliasIds(root, link))} /><span className={ghh.grpLinkText}>{link.label}</span></span>{tag ? <span className={soft ? `${ghh.linkTag} ${ghh.linkTagSoft}` : ghh.linkTag}>{tag}</span> : null}</a></li>;
      };
      $[13] = badges;
      $[14] = navIcons;
      $[15] = root;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    t4 = group.items.map(t5);
    $[8] = badges;
    $[9] = group.items;
    $[10] = navIcons;
    $[11] = root;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[17] !== group.more?.label || $[18] !== moreHref || $[19] !== showMore) {
    t5 = showMore && moreHref ? <li className={ghh.grpMore}><a href={moreHref}>{group.more?.label || "More"}</a></li> : null;
    $[17] = group.more?.label;
    $[18] = moreHref;
    $[19] = showMore;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== t4 || $[22] !== t5) {
    t6 = <ul>{t4}{t5}</ul>;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== t3 || $[25] !== t6) {
    t7 = <div className={ghh.grp}>{t3}{t6}</div>;
    $[24] = t3;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
}
function ProductCardMark(t0) {
  const $ = _c(8);
  const {
    card
  } = t0;
  let t1;
  if ($[0] !== card.logoUrl) {
    t1 = card.logoUrl?.trim();
    $[0] = card.logoUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const markSrc = t1;
  if (markSrc) {
    let t2;
    if ($[2] !== markSrc) {
      t2 = <img alt="" height={38} src={markSrc} width={38} />;
      $[2] = markSrc;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (parseGroupHeaderProductMarkKind(card.markKind) === "icon") {
    let t2;
    if ($[4] !== card.svgMarkup) {
      t2 = card.svgMarkup?.trim() ? sanitizeIconifySvgMarkup(card.svgMarkup) : null;
      $[4] = card.svgMarkup;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    const safe = t2;
    if (safe) {
      let t3;
      if ($[6] !== safe) {
        t3 = <span aria-hidden={true} className={ghh.prodMarkIcon} dangerouslySetInnerHTML={{
          __html: safe
        }} />;
        $[6] = safe;
        $[7] = t3;
      } else {
        t3 = $[7];
      }
      return t3;
    }
  }
  return card.mono.trim() ? card.mono : "\u2022";
}
function ProductCard(t0) {
  const $ = _c(30);
  const {
    card
  } = t0;
  const primary = card.ctas[0];
  const secondary = card.ctas[1];
  let t1;
  if ($[0] !== card.accent || $[1] !== card.accentDeep) {
    t1 = {
      "--ghh-prod-acc": card.accent,
      "--ghh-prod-deep": card.accentDeep
    };
    $[0] = card.accent;
    $[1] = card.accentDeep;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = t1 as CSSProperties;
  let t3;
  if ($[3] !== card) {
    t3 = <span className={ghh.prodMark}><ProductCardMark card={card} /></span>;
    $[3] = card;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== card.name) {
    t4 = <b className={ghh.prodName}>{card.name}</b>;
    $[5] = card.name;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== card.subtitle) {
    t5 = card.subtitle ? <span className={ghh.prodSub}>{card.subtitle}</span> : null;
    $[7] = card.subtitle;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <div className={ghh.prodHead}>{t3}{t6}</div>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== card.id || $[16] !== card.links) {
    let t9;
    if ($[18] !== card.id) {
      t9 = link => <li key={`${card.id}-${link.label}-${link.href}`}><a href={link.href}>{link.label}{link.badge ? <span className={ghh.linkTag}>{link.badge}</span> : null}</a></li>;
      $[18] = card.id;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    t8 = card.links.map(t9);
    $[15] = card.id;
    $[16] = card.links;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = <ul>{t8}</ul>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== primary || $[23] !== secondary) {
    t10 = primary || secondary ? <div className={ghh.prodFoot}>{primary?.enabled ? <a className={`${ghh.btn} ${ghh.btnPrimary} ${ghh.btnSm}`} href={primary.href}>{primary.label}</a> : null}{secondary?.enabled ? <a className={`${ghh.btn} ${ghh.btnGhost} ${ghh.btnSm}`} href={secondary.href}>{secondary.label}</a> : null}</div> : null;
    $[22] = primary;
    $[23] = secondary;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t2 || $[27] !== t7 || $[28] !== t9) {
    t11 = <div className={ghh.prod} style={t2}>{t7}{t9}{t10}</div>;
    $[25] = t10;
    $[26] = t2;
    $[27] = t7;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}
function FeaturedFromGroup(t0) {
  const $ = _c(31);
  const {
    card
  } = t0;
  if (card.contentMode === "html") {
    let t1;
    if ($[0] !== card.html) {
      t1 = card.html?.trim() ?? "";
      $[0] = card.html;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const html = t1;
    if (!html) {
      return null;
    }
    let t2;
    if ($[2] !== html) {
      t2 = <div className={ghh.featHtml} dangerouslySetInnerHTML={{
        __html: html
      }} />;
      $[2] = html;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let featVars;
  if ($[4] !== card.gradientMid || $[5] !== card.mutedTextColor || $[6] !== card.textColor) {
    featVars = {};
    if (card.gradientMid?.trim()) {
      featVars["--ghh-feat-mid"] = card.gradientMid;
    }
    if (card.textColor?.trim()) {
      featVars.color = card.textColor;
    }
    if (card.mutedTextColor?.trim()) {
      featVars["--ghh-feat-body"] = card.mutedTextColor;
      featVars["--ghh-feat-lbl"] = card.mutedTextColor;
    }
    $[4] = card.gradientMid;
    $[5] = card.mutedTextColor;
    $[6] = card.textColor;
    $[7] = featVars;
  } else {
    featVars = $[7];
  }
  const featStyle = featVars as CSSProperties;
  const t1 = `${ghh.feat} ${card.ringsEnabled === false ? ghh.featNoRings : ""}`;
  let t2;
  if ($[8] !== card.label) {
    t2 = card.label ? <div className={ghh.featLbl}>{card.label}</div> : null;
    $[8] = card.label;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== card.title) {
    t3 = <h4>{card.title}</h4>;
    $[10] = card.title;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== card.body) {
    t4 = card.body ? <p>{card.body}</p> : null;
    $[12] = card.body;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <div>{t2}{t3}{t4}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== card.metric || $[19] !== card.metricCaption) {
    t6 = card.metric ? <div className={ghh.featBig}>{card.metric}{card.metricCaption ? <small>{card.metricCaption}</small> : null}</div> : null;
    $[18] = card.metric;
    $[19] = card.metricCaption;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== card.cta.enabled || $[22] !== card.cta.href || $[23] !== card.cta.label) {
    t7 = card.cta.enabled ? <a className={`${ghh.btn} ${ghh.btnSm}`} href={card.cta.href}>{card.cta.label}</a> : null;
    $[21] = card.cta.enabled;
    $[22] = card.cta.href;
    $[23] = card.cta.label;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== featStyle || $[26] !== t1 || $[27] !== t5 || $[28] !== t6 || $[29] !== t7) {
    t8 = <aside className={t1} style={featStyle}>{t5}{t6}{t7}</aside>;
    $[25] = featStyle;
    $[26] = t1;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
}
const VISIBLE_DEADLINE_TILES = 3;
/** Single column until this many links; then fill col 1, then col 2 (max 2). */
const LEFT_TAB_TWO_COL_AFTER = 6;
type DeadlineItem = NonNullable<GroupHeaderPanelConfig["deadlines"]>["items"][number];
function deadlineCountClass(past: boolean, soon: boolean): string {
  if (past) {
    return `${ghh.dlCount} ${ghh.dlCountPast}`;
  }
  if (soon) {
    return `${ghh.dlCount} ${ghh.dlCountSoon}`;
  }
  return ghh.dlCount;
}
function DeadlineCard(t0) {
  const $ = _c(29);
  const {
    item,
    soonThresholdDays
  } = t0;
  const n = daysUntilIso(item.isoDate);
  const past = n < 0;
  const soon = !past && n < soonThresholdDays;
  let t1;
  if ($[0] !== item.isoDate || $[1] !== item.subtitle) {
    t1 = formatReplicaDeadlineCaption(item.isoDate, item.subtitle);
    $[0] = item.isoDate;
    $[1] = item.subtitle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const caption = t1;
  let t2;
  if ($[3] !== past || $[4] !== soon) {
    t2 = deadlineCountClass(past, soon);
    $[3] = past;
    $[4] = soon;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== n || $[7] !== past) {
    t3 = past ? <><b>Past</b><small>due</small></> : <><b>{n}</b><small>days</small></>;
    $[6] = n;
    $[7] = past;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== item.title) {
    t5 = <b>{item.title}</b>;
    $[12] = item.title;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== caption) {
    t6 = <small>{caption}</small>;
    $[14] = caption;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div className={ghh.dlBody}>{t5}{t6}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t4 || $[20] !== t7) {
    t8 = <>{t4}{t7}</>;
    $[19] = t4;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const inner = t8;
  let t9;
  if ($[22] !== item.href) {
    t9 = item.href?.trim();
    $[22] = item.href;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const href = t9;
  if (href && href !== "#") {
    let t10;
    if ($[24] !== href || $[25] !== inner) {
      t10 = <a className={ghh.dl} href={href}>{inner}</a>;
      $[24] = href;
      $[25] = inner;
      $[26] = t10;
    } else {
      t10 = $[26];
    }
    return t10;
  }
  let t10;
  if ($[27] !== inner) {
    t10 = <div className={ghh.dl}>{inner}</div>;
    $[27] = inner;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}
function DeadlineOverflow(t0) {
  const $ = _c(15);
  const {
    href,
    overflow
  } = t0;
  let t1;
  if ($[0] !== overflow) {
    t1 = <b>+{overflow}</b>;
    $[0] = overflow;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <small>more</small>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className={ghh.dlCount}>{t1}{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={ghh.dlBody}><b>More dates</b><small>On the calendar</small></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <>{t3}{t4}</>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const inner = t5;
  let t6;
  if ($[8] !== href) {
    t6 = href?.trim();
    $[8] = href;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const safeHref = t6;
  if (safeHref && safeHref !== "#") {
    let t7;
    if ($[10] !== inner || $[11] !== safeHref) {
      t7 = <a className={`${ghh.dl} ${ghh.dlOverflow}`} href={safeHref}>{inner}</a>;
      $[10] = inner;
      $[11] = safeHref;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    return t7;
  }
  let t7;
  if ($[13] !== inner) {
    t7 = <div className={`${ghh.dl} ${ghh.dlOverflow}`}>{inner}</div>;
    $[13] = inner;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function DeadlinesStrip(t0) {
  const $ = _c(27);
  const {
    heading,
    items,
    moreHref,
    moreLabel,
    soonThresholdDays
  } = t0;
  let overflow;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== heading || $[1] !== items || $[2] !== soonThresholdDays) {
    const visible = items.slice(0, VISIBLE_DEADLINE_TILES);
    overflow = items.length - visible.length;
    t3 = `${ghh.deadlines} ${ghh.deadlinesInline}`;
    if ($[8] !== heading) {
      t4 = <h5 className={ghh.deadlinesKicker}>{heading}</h5>;
      $[8] = heading;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t1 = ghh.deadlinesTiles;
    let t5;
    if ($[10] !== soonThresholdDays) {
      t5 = item => <DeadlineCard item={item} key={item.id} soonThresholdDays={soonThresholdDays} />;
      $[10] = soonThresholdDays;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t2 = visible.map(t5);
    $[0] = heading;
    $[1] = items;
    $[2] = soonThresholdDays;
    $[3] = overflow;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    overflow = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[12] !== moreHref || $[13] !== overflow) {
    t5 = overflow > 0 ? <DeadlineOverflow href={moreHref} overflow={overflow} /> : null;
    $[12] = moreHref;
    $[13] = overflow;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t1 || $[16] !== t2 || $[17] !== t5) {
    t6 = <div className={t1}>{t2}{t5}</div>;
    $[15] = t1;
    $[16] = t2;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== moreHref || $[20] !== moreLabel) {
    t7 = moreHref ? <a className={ghh.deadlinesMore} href={moreHref}>{moreLabel || "Full calendar"}</a> : null;
    $[19] = moreHref;
    $[20] = moreLabel;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t3 || $[23] !== t4 || $[24] !== t6 || $[25] !== t7) {
    t8 = <aside className={t3}>{t4}{t6}{t7}</aside>;
    $[22] = t3;
    $[23] = t4;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}
function StatusChip(t0) {
  const $ = _c(7);
  const {
    inGrid,
    label,
    updatedLabel
  } = t0;
  const t1 = `${ghh.status} ${inGrid ? ghh.statusWide : ""}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <i className={ghh.statusDot} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== updatedLabel) {
    t3 = updatedLabel?.trim() ? <span className={ghh.statusMeta}>{updatedLabel}</span> : null;
    $[1] = updatedLabel;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== label || $[4] !== t1 || $[5] !== t3) {
    t4 = <div className={t1}>{t2}{label}{t3}</div>;
    $[3] = label;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function LeftTabsLayout(t0) {
  const $ = _c(51);
  const {
    badges,
    featuredBlock,
    groups,
    products,
    navIcons,
    root
  } = t0;
  const tablistId = useId();
  const [selectedId, setSelectedId] = useState(groups[0]?.id ?? "");
  let t1;
  if ($[0] !== groups) {
    t1 = groups.map(_temp).join("\0");
    $[0] = groups;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const groupIds = t1;
  let t2;
  let t3;
  if ($[2] !== groupIds || $[3] !== selectedId) {
    t2 = () => {
      const ids = groupIds.length > 0 ? groupIds.split("\0") : [];
      if (ids.includes(selectedId)) {
        return;
      }
      setSelectedId(ids[0] ?? "");
    };
    t3 = [groupIds, selectedId];
    $[2] = groupIds;
    $[3] = selectedId;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== groups || $[7] !== selectedId) {
    t4 = groups.find(group_0 => group_0.id === selectedId) ?? groups[0] ?? null;
    $[6] = groups;
    $[7] = selectedId;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const selected = t4;
  let t5;
  if ($[9] !== groups || $[10] !== selected) {
    t5 = selected ? groups.findIndex(group_1 => group_1.id === selected.id) : -1;
    $[9] = groups;
    $[10] = selected;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const selectedIndex = t5;
  let t6;
  if ($[12] !== groups || $[13] !== tablistId) {
    t6 = nextIndex => {
      const clamped = Math.min(Math.max(nextIndex, 0), groups.length - 1);
      const next = groups[clamped];
      if (!next) {
        return;
      }
      setSelectedId(next.id);
      document.getElementById(`${tablistId}-tab-${next.id}`)?.focus();
    };
    $[12] = groups;
    $[13] = tablistId;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const moveSelection = t6;
  let t7;
  if ($[15] !== groups.length || $[16] !== moveSelection || $[17] !== selectedIndex) {
    t7 = event => {
      if (groups.length === 0) {
        return;
      }
      if (event.key === "ArrowDown" || event.key === "ArrowRight") {
        event.preventDefault();
        moveSelection(selectedIndex + 1);
        return;
      }
      if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
        event.preventDefault();
        moveSelection(selectedIndex - 1);
        return;
      }
      if (event.key === "Home") {
        event.preventDefault();
        moveSelection(0);
        return;
      }
      if (event.key === "End") {
        event.preventDefault();
        moveSelection(groups.length - 1);
      }
    };
    $[15] = groups.length;
    $[16] = moveSelection;
    $[17] = selectedIndex;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const onRailKeyDown = t7;
  const paneHasFeat = Boolean(featuredBlock);
  const paneHasProducts = products.length > 0;
  const selectedMoreHref = selected?.more?.href?.trim();
  const selectedLinkCount = (selected?.items.length ?? 0) + (selectedMoreHref && selectedMoreHref !== "#" ? 1 : 0);
  const twoColLinks = selectedLinkCount > LEFT_TAB_TWO_COL_AFTER;
  const tabLinkRows = twoColLinks ? Math.ceil(selectedLinkCount / 2) : 0;
  let t8;
  if ($[19] !== groups || $[20] !== navIcons || $[21] !== root || $[22] !== selected?.id || $[23] !== tablistId) {
    let t9;
    if ($[25] !== navIcons || $[26] !== root || $[27] !== selected?.id || $[28] !== tablistId) {
      t9 = group_2 => {
        const selectedTab = group_2.id === selected?.id;
        return <button aria-controls={`${tablistId}-panel`} aria-selected={selectedTab} className={selectedTab ? `${ghh.tabRailBtn} ${ghh.tabRailBtnSelected}` : ghh.tabRailBtn} id={`${tablistId}-tab-${group_2.id}`} key={group_2.id} onClick={() => setSelectedId(group_2.id)} onPointerEnter={() => setSelectedId(group_2.id)} role="tab" tabIndex={selectedTab ? 0 : -1} type="button"><span className={ghh.tabRailLabel}><span className={ghh.iconLabel}><NavIconSpan className={ghh.navIcon} icon={lookupNavIcon(navIcons, group_2.id, replicaGroupIconAliasIds(root, group_2))} />{group_2.label}</span><span className={ghh.tabRailCount}>{group_2.items.length}</span></span></button>;
      };
      $[25] = navIcons;
      $[26] = root;
      $[27] = selected?.id;
      $[28] = tablistId;
      $[29] = t9;
    } else {
      t9 = $[29];
    }
    t8 = groups.map(t9);
    $[19] = groups;
    $[20] = navIcons;
    $[21] = root;
    $[22] = selected?.id;
    $[23] = tablistId;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[30] !== onRailKeyDown || $[31] !== t8) {
    t9 = <div aria-label="Mega menu categories" className={ghh.tabRail} onKeyDown={onRailKeyDown} role="tablist">{t8}</div>;
    $[30] = onRailKeyDown;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  const t10 = selected ? `${tablistId}-tab-${selected.id}` : undefined;
  const t11 = `${tablistId}-panel`;
  let t12;
  if ($[33] !== badges || $[34] !== featuredBlock || $[35] !== navIcons || $[36] !== paneHasFeat || $[37] !== paneHasProducts || $[38] !== products || $[39] !== root || $[40] !== selected || $[41] !== tabLinkRows || $[42] !== twoColLinks) {
    t12 = selected ? <div className={paneHasFeat ? `${ghh.tabPaneInner} ${ghh.tabPaneWithFeat}` : ghh.tabPaneInner}><div className={twoColLinks ? `${ghh.tabPaneLinks} ${ghh.tabPaneLinksCols}` : ghh.tabPaneLinks} style={twoColLinks ? {
        "--ghh-tab-link-rows": tabLinkRows
      } as CSSProperties : undefined}><DenseGroup badges={badges} group={selected} hideHeading={true} navIcons={navIcons} root={root} />{paneHasProducts ? products.map(_temp2) : null}</div>{featuredBlock}</div> : <p className={ghh.tabPaneEmpty}>Add menu groups under this mega tab — they become the left tabs.</p>;
    $[33] = badges;
    $[34] = featuredBlock;
    $[35] = navIcons;
    $[36] = paneHasFeat;
    $[37] = paneHasProducts;
    $[38] = products;
    $[39] = root;
    $[40] = selected;
    $[41] = tabLinkRows;
    $[42] = twoColLinks;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  let t13;
  if ($[44] !== t10 || $[45] !== t11 || $[46] !== t12) {
    t13 = <div aria-labelledby={t10} className={ghh.tabPane} id={t11} role="tabpanel">{t12}</div>;
    $[44] = t10;
    $[45] = t11;
    $[46] = t12;
    $[47] = t13;
  } else {
    t13 = $[47];
  }
  let t14;
  if ($[48] !== t13 || $[49] !== t9) {
    t14 = <div className={`${ghh.pg} ${ghh.pgTabs}`} data-ghh-grid="tabs">{t9}{t13}</div>;
    $[48] = t13;
    $[49] = t9;
    $[50] = t14;
  } else {
    t14 = $[50];
  }
  return t14;
}
function _temp2(card) {
  return <ProductCard card={card} key={card.id} />;
}
function _temp(group) {
  return group.id;
}
export function ReplicaMegaPanel(t0) {
  const $ = _c(59);
  const {
    root,
    layout,
    contact,
    cta,
    badges,
    moreLinks,
    navIcons
  } = t0;
  const kind = layout?.layout ?? "dense_columns_featured";
  let t1;
  if ($[0] !== badges || $[1] !== contact || $[2] !== cta || $[3] !== kind || $[4] !== layout || $[5] !== moreLinks || $[6] !== navIcons || $[7] !== root) {
    const groups = resolvePanelGroups(root, layout, moreLinks);
    let t2;
    if ($[9] !== layout?.products) {
      t2 = layout?.products ?? [];
      $[9] = layout?.products;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    const products = t2;
    const featuredGroup = layout?.featured;
    const deadlineItems = layout?.deadlines?.items ?? [];
    const footer = layout?.footer;
    const footerLinks = (footer?.links ?? []).filter(_temp3);
    const footerCtas = (footer?.ctas ?? []).filter(_temp4);
    const barCtas = [contact.enabled ? contact : null, cta.enabled ? cta : null].filter(_temp5);
    const footCtas = footerCtas.length > 0 ? footerCtas : barCtas;
    const showFeatured = replicaShowsFeaturedAside(kind, featuredGroup);
    const showDeadlines = replicaShowsDeadlinesAside(kind, layout?.deadlines?.enabled, deadlineItems.length);
    let t3;
    if ($[11] !== layout?.status?.label) {
      t3 = layout?.status?.label?.trim() ?? "";
      $[11] = layout?.status?.label;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    const statusLabel = t3;
    const showStatus = layout?.status?.enabled === true && statusLabel.length > 0;
    let t4;
    if ($[13] !== kind) {
      t4 = replicaStatusSitsInGrid(kind);
      $[13] = kind;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    const statusInGrid = t4;
    const footerEnabled = footer?.enabled !== false;
    const showFooterChrome = footerEnabled && Boolean(footer?.message?.trim() || footerLinks.length > 0 || footCtas.length > 0);
    const showFooter = showFooterChrome || showDeadlines;
    let t5;
    if ($[15] !== kind) {
      t5 = replicaIsLeftTabsLayout(kind);
      $[15] = kind;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    const isLeftTabs = t5;
    const asideRail = replicaPanelUsesAsideRail(showFeatured, showDeadlines);
    let t6;
    if ($[17] !== kind || $[18] !== products) {
      t6 = kind === "product_cards_groups" ? products.map(_temp6) : null;
      $[17] = kind;
      $[18] = products;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    let t7;
    if ($[20] !== badges || $[21] !== navIcons || $[22] !== root) {
      t7 = group => <DenseGroup badges={badges} group={group} key={group.id} navIcons={navIcons} root={root} />;
      $[20] = badges;
      $[21] = navIcons;
      $[22] = root;
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    const t8 = groups.map(t7);
    let t9;
    if ($[24] !== layout?.status?.updatedLabel || $[25] !== showStatus || $[26] !== statusInGrid || $[27] !== statusLabel) {
      t9 = showStatus && statusInGrid ? <StatusChip inGrid={true} label={statusLabel} updatedLabel={layout?.status?.updatedLabel} /> : null;
      $[24] = layout?.status?.updatedLabel;
      $[25] = showStatus;
      $[26] = statusInGrid;
      $[27] = statusLabel;
      $[28] = t9;
    } else {
      t9 = $[28];
    }
    let t10;
    if ($[29] !== t6 || $[30] !== t8 || $[31] !== t9) {
      t10 = <>{t6}{t8}{t9}</>;
      $[29] = t6;
      $[30] = t8;
      $[31] = t9;
      $[32] = t10;
    } else {
      t10 = $[32];
    }
    const mainColumns = t10;
    let t11;
    if ($[33] !== featuredGroup || $[34] !== showFeatured) {
      t11 = showFeatured && featuredGroup ? <FeaturedFromGroup card={{
        ...featuredGroup,
        enabled: true
      }} /> : null;
      $[33] = featuredGroup;
      $[34] = showFeatured;
      $[35] = t11;
    } else {
      t11 = $[35];
    }
    const featuredBlock = t11;
    let t12;
    if ($[36] !== deadlineItems || $[37] !== layout?.deadlines?.heading || $[38] !== layout?.deadlines?.moreHref || $[39] !== layout?.deadlines?.moreLabel || $[40] !== layout?.deadlines?.soonThresholdDays || $[41] !== showDeadlines) {
      t12 = showDeadlines ? <DeadlinesStrip heading={layout?.deadlines?.heading || "Upcoming dates"} items={deadlineItems} moreHref={layout?.deadlines?.moreHref} moreLabel={layout?.deadlines?.moreLabel} soonThresholdDays={layout?.deadlines?.soonThresholdDays ?? 45} /> : null;
      $[36] = deadlineItems;
      $[37] = layout?.deadlines?.heading;
      $[38] = layout?.deadlines?.moreHref;
      $[39] = layout?.deadlines?.moreLabel;
      $[40] = layout?.deadlines?.soonThresholdDays;
      $[41] = showDeadlines;
      $[42] = t12;
    } else {
      t12 = $[42];
    }
    const deadlinesBlock = t12;
    let t13;
    if ($[43] !== asideRail || $[44] !== badges || $[45] !== featuredBlock || $[46] !== groups || $[47] !== isLeftTabs || $[48] !== kind || $[49] !== mainColumns || $[50] !== navIcons || $[51] !== products || $[52] !== root) {
      t13 = isLeftTabs ? <LeftTabsLayout badges={badges} featuredBlock={featuredBlock} groups={groups} navIcons={navIcons} products={products} root={root} /> : <div className={`${ghh.pg} ${replicaGridClass(kind)}${asideRail ? ` ${ghh.pgAside}` : ""}`} data-ghh-grid={replicaGridClassName(kind)}>{asideRail ? <div className={ghh.pgMain}>{mainColumns}</div> : mainColumns}{featuredBlock}</div>;
      $[43] = asideRail;
      $[44] = badges;
      $[45] = featuredBlock;
      $[46] = groups;
      $[47] = isLeftTabs;
      $[48] = kind;
      $[49] = mainColumns;
      $[50] = navIcons;
      $[51] = products;
      $[52] = root;
      $[53] = t13;
    } else {
      t13 = $[53];
    }
    let t14;
    if ($[54] !== layout?.status?.updatedLabel || $[55] !== showStatus || $[56] !== statusInGrid || $[57] !== statusLabel) {
      t14 = showStatus && !statusInGrid ? <StatusChip inGrid={false} label={statusLabel} updatedLabel={layout?.status?.updatedLabel} /> : null;
      $[54] = layout?.status?.updatedLabel;
      $[55] = showStatus;
      $[56] = statusInGrid;
      $[57] = statusLabel;
      $[58] = t14;
    } else {
      t14 = $[58];
    }
    t1 = <section className={ghh.panelShell}>{t13}{t14}{showFooter ? <div className={showDeadlines ? `${ghh.panelFoot} ${ghh.panelFootWithDl}` : ghh.panelFoot}>{showDeadlines ? deadlinesBlock : <span className={ghh.panelFootMsg}>{footer?.message ?? ""}</span>}{showDeadlines && footerEnabled && footer?.message?.trim() ? <span className={ghh.panelFootMsg}>{footer.message}</span> : null}{showDeadlines ? footerEnabled && footerLinks.length > 0 ? <div className={ghh.panelFootLinks}>{footerLinks.map(_temp7)}</div> : null : <div className={ghh.panelFootLinks}>{footerLinks.map(_temp8)}</div>}{footerEnabled && footCtas.length > 0 ? <div className={ghh.panelFootCtas}>{footCtas.map((item_1, index) => <a className={`${ghh.btn} ${index === footCtas.length - 1 ? ghh.btnPrimary : ghh.btnGhost} ${ghh.btnSm}`} href={item_1.href} key={`${item_1.label}-${item_1.href}-${index}`}>{item_1.label}</a>)}</div> : showDeadlines ? null : <div className={ghh.panelFootCtas} />}</div> : null}</section>;
    $[0] = badges;
    $[1] = contact;
    $[2] = cta;
    $[3] = kind;
    $[4] = layout;
    $[5] = moreLinks;
    $[6] = navIcons;
    $[7] = root;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}
function _temp8(link_1) {
  return <a href={link_1.href || "#"} key={link_1.id}>{link_1.label}</a>;
}
function _temp7(link_0) {
  return <a href={link_0.href || "#"} key={link_0.id}>{link_0.label}</a>;
}
function _temp6(card) {
  return <ProductCard card={card} key={card.id} />;
}
function _temp5(item_0) {
  return item_0 != null;
}
function _temp4(item) {
  return item.enabled;
}
function _temp3(link) {
  return link.label.trim().length > 0;
}